"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTruckFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29.76 15a10.21 10.21 0 00-4.24-5.86L25.28 9H22v6z" }),
        React.createElement("circle", { cx: 9, cy: 25, r: 3 }),
        React.createElement("path", { d: "M20 20.1V6H2v19h2a5 5 0 0110 0h2a5 5 0 014-4.9zM22 17v3.1a5 5 0 014 4.9h4v-8z" }),
        React.createElement("circle", { cx: 21, cy: 25, r: 3 })));
}
exports.default = SvgTruckFilled;
//# sourceMappingURL=TruckFilled.js.map